module.exports = __webpack_public_path__ + "img/Z60_02.32f11db7.jpg";